import { Pipe, type PipeTransform } from '@angular/core';
import type { ActiveUser } from '../../../shared/models/api/user.model';

@Pipe({
  name: 'opaFilterGroupMembers',
  standalone: true,
})
export class FilterGroupMembersPipe implements PipeTransform {
  transform(users: ActiveUser[], groupMembers: ActiveUser[] | undefined): ActiveUser[] {
    if (!groupMembers) return users;

    return users.filter((user) => !groupMembers.some((member) => member.id === user.id));
  }
}
